
import React from 'react';
import "./styles/MainMint.scss";

import { useState } from "react";
import { ethers, BigNumber } from "ethers";
import Gif from "./assets/gif.gif";
import roboPunksNFT from './questions.json';

const roboPunksNFTAddress = "0x3eCD53103695957d4b5A3561bdd284eaccEED8D9";


export default function MainMint({ accounts, setAccounts }) {

    
    const [mintAmount, setMintAmount] = useState(1);
    
    const [alreadyMinted, setAlreadyMinted] = useState(0);
    const [publicMint, setPublicMint] = useState(false);

    
    
    const isConnected = Boolean(accounts[0]);

    

    async function handleMint() {

        

        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(roboPunksNFTAddress, roboPunksNFT, signer);

            /*const count = await contract.totalSupply();
        const publicMintEnabled = await contract.isPublicMint ();
        setAlreadyMinted(count);
        setPublicMint(publicMintEnabled); */

            try {
                const response = await contract.mint(BigNumber.from(mintAmount), {
                    value: ethers.utils.parseEther((0 * mintAmount).toString())
                });
                console.log(`Response: ${response}`);
            } catch(err) {
                console.error(`Error: ${err}`);
            }
        }
    }

    async function mintStatus() {

        const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
        const contract = new ethers.Contract(roboPunksNFTAddress, roboPunksNFT, signer)

        
        const count = await contract.totalSupply();
        const publicMintEnabled = await contract.isPublicMint ();
        setAlreadyMinted(count);
        setPublicMint(publicMintEnabled);
       
    }
         
    
            

    

    function handleDecrement() {
        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);
    }

    function handleIncrement() {
        if (mintAmount >= 3) return;
        setMintAmount(mintAmount + 1);
    }
    mintStatus();
    return (
        <section className="mainMint">
            <h1>Canto Cuties</h1>
            <p>
                A collection of 1111 unique NFTs on the Canto blockchain.
            </p> 

            
            
            <p><img src={Gif} border="5" solid="555" alt="gif"></img></p>
            
           
            {
                isConnected ? (
                    <div>
                        <div className="inputContainer">
                            <button onClick={handleDecrement}>-</button>
                            <input type="number" value={mintAmount} readOnly />
                            <button onClick={handleIncrement}>+</button>
                        </div>
                        <button onClick={handleMint}>Mint Now!</button>
                    </div>
                ) : (
                    <p>You must be connected to mint</p>
                )
            }
           
           {
                    isConnected ? 
                    (<p>{alreadyMinted.toString()}/1111 minted</p> ) : ( <p>?/1111 minted</p> )
                }
           
                
            
           
        </section>
    );
}